<div *ngIf="toast.message() as message" class="inline-toast" role="status">
    {{ message.key | translate: message.params }}
</div>